import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navigation.css";

function Navigation() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <h1>Aira Guidelines Management</h1>
        </Link>
        <div className="nav-links">
          <Link
            to="/documents"
            className={`nav-link ${isActive("/documents") ? "active" : ""}`}
          >
            Document Management
          </Link>
          <Link
            to="/guidelines"
            className={`nav-link ${isActive("/guidelines") ? "active" : ""}`}
          >
            Guidelines Management
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
